import React, {useEffect, useState} from "react";
import {css, useTheme} from "@emotion/react";

import {mb, onDesktop, p, pt} from "@pg-design/helpers-css";
import {BellIcon} from "@pg-design/icons-module";

import {FeedbackPopup} from "../../../atoms/chat_bot/feedback_popup/components/FeedbackPopup";
import {useFeedbackPopup} from "../../../atoms/chat_bot/feedback_popup/hooks/use_feedback_popup";
import {useOfferChatbotStorage} from "../../hooks/use_offer_chatbot_storage";
import {hitGtmWhatsAppPopupView} from "../../tracking/whatsapp_gtm_events";
import {OfferChatBotHeader} from "./atoms/OfferChatBotHeader";
import {OfferChatBotForm} from "./OfferChatBotForm";
import {OfferChatBotThankYouBox} from "./OfferChatBotThankYouBox";

interface IProps {
    shouldPopupBeOpened?: boolean;
    onShouldPopupBeOpenened?: () => void;
}

export const OfferChatBot = (props: IProps) => {
    const theme = useTheme();
    const [hasFormBeenSend, setFormSendStatus] = useState(false);
    const {isOfferChatBotAvailable, syncStorageOnFormSubmit, setIsOfferChatBotAvailable} = useOfferChatbotStorage();

    const feedbackPopup = useFeedbackPopup({
        shouldOpenAfterActivationOnDesktop: false,
        shouldOpenAfterActivationOnMobile: false,
        activationDelay: 2500,
        onClose: () => {
            if (hasFormBeenSend) {
                setIsOfferChatBotAvailable(false);
            }
        }
    });

    useEffect(() => {
        if (props.shouldPopupBeOpened) {
            feedbackPopup.setIsOpen(true);
        }

        if (props.shouldPopupBeOpened && props.onShouldPopupBeOpenened) {
            props.onShouldPopupBeOpenened();
        }
    }, [props.shouldPopupBeOpened, feedbackPopup.setIsOpen]);

    useEffect(() => {
        if (feedbackPopup.feedbackPopupProps.isOpen) {
            hitGtmWhatsAppPopupView();
        }
    }, [feedbackPopup.feedbackPopupProps.isOpen]);

    const onAfterSubmit = () => {
        setFormSendStatus(true);
        syncStorageOnFormSubmit();
    };

    if (!isOfferChatBotAvailable) {
        return null;
    }

    return (
        <>
            <FeedbackPopup
                showOverlayOnMobile
                position="left"
                triggerMobile={{
                    prompt: "1",
                    slot: <BellIcon fill={theme.colors.secondary} size="3.2" />
                }}
                triggerDesktop={{
                    slot: (
                        <div css={triggerIconWrapperStyle}>
                            <BellIcon fill="#fff" size="3.2" />
                        </div>
                    )
                }}
                zIndex={10000}
                {...feedbackPopup.feedbackPopupProps}
            >
                <div css={offerChatBotContentStyle}>
                    <OfferChatBotHeader css={[mb(1.5)]} />
                    {hasFormBeenSend ? <OfferChatBotThankYouBox /> : <OfferChatBotForm onAfterSubmit={onAfterSubmit} css={[pt(2)]} />}
                </div>
            </FeedbackPopup>
        </>
    );
};

const triggerIconWrapperStyle = css`
    transform: rotate(90deg);
`;

const offerChatBotContentStyle = css`
    ${p(2, 0, 1)};

    ${onDesktop(css`
        max-width: 34rem;
    `)};
`;
import React, {useEffect, useState} from "react";
import {css, useTheme} from "@emotion/react";

import {mb, onDesktop, p, pt} from "@pg-design/helpers-css";
import {BellIcon} from "@pg-design/icons-module";

import {FeedbackPopup} from "../../../atoms/chat_bot/feedback_popup/components/FeedbackPopup";
import {useFeedbackPopup} from "../../../atoms/chat_bot/feedback_popup/hooks/use_feedback_popup";
import {useOfferChatbotStorage} from "../../hooks/use_offer_chatbot_storage";
import {hitGtmWhatsAppPopupView} from "../../tracking/whatsapp_gtm_events";
import {OfferChatBotHeader} from "./atoms/OfferChatBotHeader";
import {OfferChatBotForm} from "./OfferChatBotForm";
import {OfferChatBotThankYouBox} from "./OfferChatBotThankYouBox";

interface IProps {
    shouldPopupBeOpened?: boolean;
    onShouldPopupBeOpenened?: () => void;
}

export const OfferChatBot = (props: IProps) => {
    const theme = useTheme();
    const [hasFormBeenSend, setFormSendStatus] = useState(false);
    const {isOfferChatBotAvailable, syncStorageOnFormSubmit, setIsOfferChatBotAvailable} = useOfferChatbotStorage();

    const feedbackPopup = useFeedbackPopup({
        shouldOpenAfterActivationOnDesktop: false,
        shouldOpenAfterActivationOnMobile: false,
        activationDelay: 2500,
        onClose: () => {
            if (hasFormBeenSend) {
                setIsOfferChatBotAvailable(false);
            }
        }
    });

    useEffect(() => {
        if (props.shouldPopupBeOpened) {
            feedbackPopup.setIsOpen(true);
        }

        if (props.shouldPopupBeOpened && props.onShouldPopupBeOpenened) {
            props.onShouldPopupBeOpenened();
        }
    }, [props.shouldPopupBeOpened, feedbackPopup.setIsOpen]);

    useEffect(() => {
        if (feedbackPopup.feedbackPopupProps.isOpen) {
            hitGtmWhatsAppPopupView();
        }
    }, [feedbackPopup.feedbackPopupProps.isOpen]);

    const onAfterSubmit = () => {
        setFormSendStatus(true);
        syncStorageOnFormSubmit();
    };

    if (!isOfferChatBotAvailable) {
        return null;
    }

    return (
        <>
            <FeedbackPopup
                showOverlayOnMobile
                position="left"
                triggerMobile={{
                    prompt: "1",
                    slot: <BellIcon fill={theme.colors.secondary} size="3.2" />
                }}
                triggerDesktop={{
                    slot: (
                        <div css={triggerIconWrapperStyle}>
                            <BellIcon fill="#fff" size="3.2" />
                        </div>
                    )
                }}
                zIndex={10000}
                {...feedbackPopup.feedbackPopupProps}
            >
                <div css={offerChatBotContentStyle}>
                    <OfferChatBotHeader css={[mb(1.5)]} />
                    {hasFormBeenSend ? <OfferChatBotThankYouBox /> : <OfferChatBotForm onAfterSubmit={onAfterSubmit} css={[pt(2)]} />}
                </div>
            </FeedbackPopup>
        </>
    );
};

const triggerIconWrapperStyle = css`
    transform: rotate(90deg);
`;

const offerChatBotContentStyle = css`
    ${p(2, 0, 1)};

    ${onDesktop(css`
        max-width: 34rem;
    `)};
`;
